import { render, staticRenderFns } from "./BindWxDialog.vue?vue&type=template&id=838ec0e2&scoped=true&"
import script from "./BindWxDialog.vue?vue&type=script&lang=js&"
export * from "./BindWxDialog.vue?vue&type=script&lang=js&"
import style0 from "./BindWxDialog.vue?vue&type=style&index=0&id=838ec0e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "838ec0e2",
  null
  
)

component.options.__file = "BindWxDialog.vue"
export default component.exports